/**
 * Cancel/Merge copy and classification for Наряд-откат / Наряд-корректировка.
 * Used by TasksPage and RollbackConfirmDialog.
 */
export type WoBadgeKind = 'ROLLBACK' | 'CORRECTION' | null

export function woBadgeKind(wo: { wo_type?: string | null }): WoBadgeKind {
  if (wo.wo_type === 'ROLLBACK' || wo.wo_type === 'CORRECTION') return wo.wo_type
  return null
}

export function doneItemCount(items: { status: string }[]): number {
  return items.filter(i => i.status === 'DONE').length
}

export function cancelResultMessage(rollbackId: string | null | undefined): string {
  return rollbackId ? `Наряд отменён. Создан Наряд-откат ${rollbackId}` : 'Наряд отменён'
}

export function mergeResultMessage(correctionId: string | null | undefined): string {
  return correctionId ? `Наряд применён. Создан Наряд-корректировка ${correctionId}` : 'Изменения применены (Merged)'
}

/** Russian count word only: шаг / шага / шагов. */
export function ruWord(n: number, one: string, few: string, many: string): string {
  const n10 = Math.abs(n) % 10
  const n100 = Math.abs(n) % 100
  if (n100 >= 11 && n100 <= 14) return many
  if (n10 === 1) return one
  if (n10 >= 2 && n10 <= 4) return few
  return many
}

/** Russian count: 1 шаг, 2 шага, 5 шагов, 11 шагов, 21 шаг. */
export function ruPlural(n: number, one: string, few: string, many: string): string {
  return `${n} ${ruWord(n, one, few, many)}`
}

/** Banner title from racks that two+ EXECUTION WOs share. Null = no banner. */
export function conflictHeadline(conflictingRackCount: number): string | null {
  if (conflictingRackCount < 1) return null
  return `Конфликт нарядов: пересечение в ${ruPlural(conflictingRackCount, 'стойке', 'стойках', 'стойках')}`
}

export function cancelWarning(doneCount: number): { title: string; body: string; confirmLabel: string } {
  if (doneCount > 0) {
    const steps = doneCount === 1
      ? '1 выполненный шаг уже применён'
      : `${doneCount} выполненных шага уже применены`
    return {
      title: 'Отмена наряда с выполненными шагами',
      body: `${steps} в production (Digital Twin). Будет создан Наряд-откат с обратными операциями.`,
      confirmLabel: 'Отменить и создать Наряд-откат',
    }
  }
  return {
    title: 'Подтвердите отмену наряда',
    body: 'Наряд будет отменён. Это действие нельзя отменить.',
    confirmLabel: 'Отменить наряд',
  }
}
